
// src/services/endpoints/user.ts
export const userEndpoints = {
  // --- Users (CRUD) ---
  listUsers: '/private/v1/users',
  createUser: '/private/v1/users',
  getUserById: (id: string) => `/private/v1/users/${id}`,
  updateUserById: (id: string) => `/private/v1/users/${id}`,
  deleteUserById: (id: string) => `/private/v1/users/${id}`,

  // --- User Status & Actions ---
  updateUserStatus: (id: string) => `/private/v1/users/${id}/update-status`,
  forceUserLogout: (id: string) => `/private/v1/users/${id}/force-logout`,
  forceUserLoginCredentialsReset: (id: string) => `/private/v1/users/${id}/force-login-credentials-reset`,

  getUserInvitationLink: (id: string) => `/private/v1/users/get-invitation/${id}`,
} as const;
